import { render, staticRenderFns } from "./gType.vue?vue&type=template&id=be6a78aa&scoped=true&"
import script from "./gType.vue?vue&type=script&lang=js&"
export * from "./gType.vue?vue&type=script&lang=js&"
import style0 from "./gType.vue?vue&type=style&index=0&id=be6a78aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6a78aa",
  null
  
)

export default component.exports